module.exports = __webpack_public_path__ + "img/turn-left.652b38cb.gif";